import React from 'react';
import { localeStore } from 'src/mobx/localesStore';

interface IProps {
  title: string;
  className?: string;
}

export default class OrderBlockHeader extends React.Component<IProps, {}> {
  render() {
    return (
      <h2 className={`family-regular text-size-18 color-gray2 text-uppercase letter-spacing-12 mb-4 ${this.props.className || ''}`}>
        {localeStore.t(this.props.title)}
      </h2>
    );
  }
}
